module.exports = __webpack_public_path__ + "media/images/icons/vendors/videographer-aa72df538b9db92060591f65c3082297.png";